import React from 'react';
import './Navbar.css';
import { slide as Menu } from 'react-burger-menu'
import logo from '../images/logo.png';
import { Link} from "react-router-dom";
import {HideScroll} from "react-hide-on-scroll"



class Navbar extends React.Component {

  constructor(props) {
    super(props);
    this.state ={
      menuOpen: false
    }  
  }

  handleStateChange (state) {
    this.setState({menuOpen: state.isOpen})  
  }
  
  closeMenu () {
    this.setState({menuOpen: false})
  }

  toggleMenu () {
    this.setState(state => ({menuOpen: !state.menuOpen}))
  }


    render () {
      return (
        <div>
          <HideScroll variant="down">
            <Menu isOpen={this.state.menuOpen} onStateChange={(state) => this.handleStateChange(state)}>
              <Link to="/home" onClick={() => this.closeMenu()}>
                <i className="fa fa-home" aria-hidden="true"></i>&nbsp;Home
              </Link>
              <br />
              <Link to="/tentang" onClick={() => this.closeMenu()}>
                <i className="fa fa-users" aria-hidden="true"></i>&nbsp;Tentang
              </Link>
              <br />
              <Link to="/beli" onClick={() => this.closeMenu()}>
                <i className="fa fa-cart-plus" aria-hidden="true"></i>&nbsp;Beli Product
              </Link>
              <br />
              <Link to="/cara" onClick={() => this.closeMenu()}>
                <i className="fa fa-handshake-o" aria-hidden="true"></i>&nbsp;Cara Pembelian
              </Link>
              <br />
              <Link to="/kontak" onClick={() => this.closeMenu()}>
                <i className="fa fa-address-card" aria-hidden="true"></i>&nbsp;Kontak
              </Link>
            </Menu>
            <Link to="/home">
              <img className="logo iconW img-fluid" src={logo} alt="" />
            </Link>
          </HideScroll>
        </div>
      );
    }
  }


export default Navbar;
